import { ShieldCheck } from "lucide-react";

export function TMSHero({ enrolled, onEnroll, checkingOut, price, onScrollCurriculum, guestCheckoutEnabled }) {
  return (
    <section
      data-testid="tms-hero"
      className="relative min-h-[88vh] flex items-end overflow-hidden bg-black"
    >
      <img
        src="/tms/hero.jpg"
        alt="The Muscle School"
        className="absolute inset-0 w-full h-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(94,20,32,0.25),_transparent_60%)]" />

      <div className="relative z-10 max-w-[1300px] mx-auto px-6 md:px-12 pb-16 md:pb-24 w-full">
        <div className="flex items-center gap-3 mb-6">
          <img src="/tms/seal.png" alt="" className="w-12 h-12 rounded-full object-cover border border-[#c9962c]/50 shadow-[0_0_12px_rgba(0,0,0,0.6)]" />
          <p className="text-xs uppercase tracking-[0.35em] text-[#c9962c]">An Institution of Durable Human Capability</p>
        </div>
        <h1 className="font-display text-display-md md:text-display-xl font-medium text-ivory max-w-3xl leading-[1.05]" style={{ color: "#f4ead9" }}>
          The Muscle School
        </h1>
        <p className="mt-6 max-w-xl text-base md:text-lg text-white/75">
          Seven Acts. Thirty-five Modules. One hundred and six Lessons. An evidence-grounded curriculum
          on why the body is built the way it is — and what that demands of you.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-5">
          {enrolled ? (
            <a
              href="/themuscleschool/dashboard"
              data-testid="tms-hero-dashboard-link"
              className="bg-[#c9962c] text-black px-7 py-3.5 text-sm uppercase tracking-wide font-medium hover:bg-[#e0ad3d] transition-colors duration-200"
            >
              Continue Learning
            </a>
          ) : (
            <button
              data-testid="tms-hero-enroll-button"
              onClick={onEnroll}
              disabled={checkingOut}
              className="bg-[#5e1420] text-[#f4ead9] px-7 py-3.5 text-sm uppercase tracking-wide font-medium hover:bg-[#7a1b2b] transition-colors duration-200 disabled:opacity-50"
            >
              {checkingOut ? "Redirecting…" : <>Enroll Now — <span className="font-meta">{price != null ? `$${price}` : "$497"}</span></>}
            </button>
          )}
          <button
            data-testid="tms-hero-free-lesson-button"
            onClick={onScrollCurriculum}
            className="text-sm uppercase tracking-wide text-white/80 border border-white/30 px-7 py-3.5 hover:border-white/60 hover:text-white transition-colors duration-200"
          >
            Read Lesson I.1.1 — Free
          </button>
        </div>
        {!enrolled && (
          <p data-testid="tms-hero-secure-checkout-badge" className="text-xs text-white/50 flex items-center gap-1.5 mt-5">
            <ShieldCheck className="w-3.5 h-3.5 text-[#c9962c]" />
            {guestCheckoutEnabled ? "No account required to start checkout · Lifetime access · No subscription" : "Sign in with Google to enroll · Lifetime access · No subscription"}
          </p>
        )}
      </div>
    </section>
  );
}
